import Bus from '@/utils/eventBus';
export default new Bus();
